//校验工具包

let context;
//非空且有校验的参数数组
const notNullParms = [
	["购方税号","buyerTaxno",/^[0-9a-zA-Z]{15,20}$/,'购方税号应为字母、数字组成且不少于15个字符，不超过20个字符！'],	
	["机构名称","companyName", /^[\w\u4e00-\u9fa5A-Za-z_()\（\）\(\)]*$/,'机构名称应为汉字、字母、字符组成，且最大长度为150个字符以内！'],	
	["联系电话","telephoneNum",/^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/,'电话格式不正确，请重新输入！'],	
	["滑块验证码证书","cert",/[\s\S]*/,'滑块验证码证书失效或者未验证,请验证滑块验证码！'],	
	['用户名','username',/^\w{0,50}$/,'用户名由字母、数字组成且不超过50个字符！'],
	['当前密码','password',/^[A-Za-z0-9\!\.\@\#\$\%\^\&\*\(\)\[\]\\?\\\/\|\-~`\+\=\,\r\n\:\'\"]{6,20}$/,'当前密码由数字、字母、英文标点组成且不少于6个字符，不超过20个字符！'],
	['用户名','inputUsername',/^\w{0,50}$/,'用户名由字母、数字组成且不超过50个字符！'],
	['当前密码','inputPassword',/^[A-Za-z0-9\!\.\@\#\$\%\^\&\*\(\)\[\]\\?\\\/\|\-~`\+\=\,\r\n\:\'\"]{6,20}$/,'当前密码由数字、字母、英文标点组成且不少于6个字符，不超过20个字符！'],
	['新密码','newPassword',/^[A-Za-z0-9\!\.\@\#\$\%\^\&\*\(\)\[\]\\?\\\/\|\-~`\+\=\,\r\n\:\'\"]{6,20}$/,'新密码由数字、字母、英文标点组成且不少于6个字符，不超过20个字符！'],
	['确认密码','confirmPsd',/^[A-Za-z0-9\!\.\@\#\$\%\^\&\*\(\)\[\]\\?\\\/\|\-~`\+\=\,\r\n\:\'\"]{6,20}$/,'确认密码由数字、字母、英文标点组成且不少于6个字符，不超过20个字符！'],
	['姓名','name',/^[\w\u4e00-\u9fa5]{0,50}$/,'姓名由汉字、字母、数字组成且不超过50个字符！'],
	['电话','phone',/^((13[0-9])|(14[0-9])|(15([0-9]))|(18[0-9])|(17[0-9]))\d{8}$/,'电话格式不正确，请重新输入！'],
	['邮箱','email',/^[A-Za-z0-9]+([-_.][A-Za-z0-9]+)*@([A-Za-z0-9]+[-.])+[A-Za-z]{2,5}$/,'邮箱格式不正确，请重新输入！'],
	["短信验证码","smsCode",/^[0-9]{6}$/,'短信验证码格式不正确，应该为6位数字！']	
	
];
//可以为空但是如果有值就需要有校验的参数
const canNullParms = [];

function check(parm,re,errorMessage,name){
	
	if(!re.test(parm)){
		context.$Message.error({
		    content: errorMessage,
		    duration: 2
		})
		return false
	}else if(name =='邮箱'){
		if(parm.length>80){
			context.$Message.error({
			    content: errorMessage,
			    duration: 2
			})
			return false
		}
	}
	return true
}
function notNull(name){
	if(name == "滑块验证码证书"){
		context.$Message.error({
		    content: '证书已经失效，请重新验证滑块验证，获取滑块验证证书！',
		    duration: 2
		})
	}else{
		context.$Message.error({
		    content: name+'不能为空',
		    duration: 2
		})
	}
	
//	return false
}

export default {
	initContext(vue) {
		context = vue;
	},
	//主要用于检测参数的格式是否符合要求
	calibration(params){	
		var isbreak = false;
		for(var i = 0,len = notNullParms.length;i < len;i++){
			for(var j in params){
				if(j == notNullParms[i][1]){
					if(params[notNullParms[i][1]]){
						if(!check(params[notNullParms[i][1]],notNullParms[i][2],notNullParms[i][3],notNullParms[i][0])){
							isbreak = true;
							break;
						}
					}else{
						notNull(notNullParms[i][0])
						isbreak = true;
						break;
					}
				}
			}
			if(isbreak){
				break;
			}
		}
		return !isbreak
	},
	//校验是否登录
	checkSession(vue){
//		if(!sessionStorage.getItem('certificate')){
//			vue.$router.push('/login')
//			return false
//		}else{
			return true
//		}
	},
	//清除页面缓存
	clearCache(vue){
		
	}
}	


// WEBPACK FOOTER //
// ./src/utils/check.js